import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// Import react-bootstrap components
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

const SearchForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchQuery, setSearchQuery] = useState('');

  // Read the 's' parameter from the URL and set it as the initial search query
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const initialQuery = searchParams.get('s') || '';
    setSearchQuery(initialQuery);
  }, [location.search]);

  const handleSearch = (e) => {
    e.preventDefault();

    // Get the current query parameters from the URL
    const searchParams = new URLSearchParams(location.search);

    // Set or update the 's' parameter with the search query
    searchParams.set('s', searchQuery);

    // Construct the new URL
    const newUrl = `/search?${searchParams.toString()}`;

    // Navigate to the new URL
    navigate(newUrl);
  };

  const [showSearchBar, setShowSearchBar] = useState(false);

  const toggleSearchBar = () => {
    setShowSearchBar(!showSearchBar);
  };

  return (
    <>
      <i className="bi bi-search fs-5 ms-3 d-md-none cursor-pointer" onClick={toggleSearchBar}></i>
      <div className={`search-bar ${showSearchBar ? 'search-bar-show' : ''}`}>
        <Form
          className="search-form d-flex align-items-center"
          onSubmit={handleSearch}
        >
          <Form.Control
            required
            role="search"
            type="search"
            name="q"
            placeholder="Enter name, email, phone, employeeId"
            title="Enter name, email, phone, employeeId"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <Button type="submit" title="Search">
            <i className="bi bi-search"></i>
          </Button>
        </Form>
      </div>
    </>
  );
};

export default SearchForm;